const _excluded = ["value", "onChange", "onBlur", "disabled", "enableTime", "visibleFormat", "visibleNumberFormat", "storeFormat"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { formatToFormat } from '@isyc-react/core/dayjs';
import { InputDate } from '@isyc-react/form/modules/input/date';
export const InputParameterDate = props => {
  const {
      value = '',
      onChange,
      onBlur,
      disabled,
      enableTime,
      visibleFormat,
      visibleNumberFormat,
      storeFormat
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [date, setDate] = React.useState('');
  const dateRef = React.useRef('');
  React.useEffect(() => {
    var _formatToFormat;
    setDate((_formatToFormat = formatToFormat(value, storeFormat, visibleFormat)) !== null && _formatToFormat !== void 0 ? _formatToFormat : '');
  }, [value]);
  React.useEffect(() => {
    dateRef.current = date;
  }, [date]);
  return /*#__PURE__*/React.createElement(InputDate, _extends({
    value: date,
    dateFormat: visibleFormat,
    numberFormat: visibleNumberFormat,
    onChange: change => {
      setDate(change);
      if (onChange) {
        const formatted = formatToFormat(change, visibleFormat, storeFormat);
        if (!change) onChange(change);else if (formatted) onChange(formatted);
      }
    },
    onBlur: () => {
      const formatted = formatToFormat(dateRef.current, visibleFormat, storeFormat);
      if (!formatted) setDate('');
      onChange && onChange(formatted !== null && formatted !== void 0 ? formatted : '');
      onBlur && onBlur();
    },
    enableTime: enableTime,
    disabled: disabled
  }, rest));
};